import React from 'react';
import { ImageReservationNumber } from '../../assets/images';
import { TranslationUtils } from '../../utils';
import './QuestionPanel.scss';

export const QuestionPanel: React.FC = () => {
    return (
        <div className="question-panel">
            <div className="question-image d-none d-sm-block">
                <ImageReservationNumber />
            </div>
            <div className="question-text">
                <h6 className="body-bold" tabIndex={0}>
                    {TranslationUtils.get('need_help')}
                </h6>
                <p className={'body-regular'}>
                    <span tabIndex={0}>
                        {TranslationUtils.get('visit_our')}
                        <a id="link-help-vacasa" target="_blank" rel="noopener noreferrer" href="https://www.vacasa.com/support">
                            {` ${TranslationUtils.get('support_center')}. `}
                        </a>
                    </span>
                </p>
            </div>
        </div>
    );
};
